import { useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Input } from "@/components/ui/input";
import { Separator } from "@/components/ui/separator";
import { Check, Palette } from "lucide-react";
import { SWATCHES } from "./swatches";

export function ColorPicker({
  value,
  onChange,
}: {
  value: string;
  onChange: (c: string) => void;
}) {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="h-7 w-7 rounded-md border shadow-inner relative overflow-hidden ring-offset-2 hover:ring-2 hover:ring-primary transition"
          style={{ backgroundColor: value }}
          title="Alterar cor"
        >
          <span className="sr-only">Cor</span>
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-[200px] p-3" align="start">
        <div className="text-xs font-medium mb-2 text-muted-foreground">Escolha uma cor</div>
        <div className="grid grid-cols-5 gap-1.5">
          {SWATCHES.map((c) => {
            const active = c.toLowerCase() === value.toLowerCase();
            return (
              <button
                key={c}
                onClick={() => {
                  onChange(c);
                  setOpen(false);
                }}
                className={`h-7 w-7 rounded-md flex items-center justify-center ring-offset-1 transition hover:scale-110 ${
                  active ? "ring-2 ring-foreground" : ""
                }`}
                style={{ backgroundColor: c }}
              >
                {active && <Check className="h-3.5 w-3.5 text-white drop-shadow" />}
              </button>
            );
          })}
        </div>
        <Separator className="my-2" />
        <div className="flex items-center gap-2">
          <Palette className="h-3.5 w-3.5 text-muted-foreground" />
          <Input
            type="color"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className="h-8 w-full cursor-pointer p-0.5"
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
